var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.9998V9.77979",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94295 21H3.56095C3.25195 21 3.00195 20.75 3.00195 20.441V16.059C3.00195 15.75 3.25195 15.5 3.56095 15.5H4.94295C5.25195 15.5 5.50195 15.75 5.50195 16.101V20.483C5.50195 20.75 5.25195 21 4.94295 21V21Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50195 19.8149L6.58395 20.7119C6.80795 20.8979 7.09095 20.9999 7.38195 20.9999H10.965C11.414 20.9999 11.809 20.7019 11.933 20.2699L12.665 17.7079C12.776 17.3209 12.711 16.9039 12.488 16.5689C12.236 16.1899 11.813 15.9629 11.36 15.9629H10.74H9.84995",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30059 9.778C2.60259 9.766 1.49559 8.085 2.23159 6.636L3.94759 3.259C4.33759 2.489 5.15959 2 6.06159 2H17.9376C18.8396 2 19.6616 2.489 20.0526 3.259L21.7686 6.636C22.5046 8.085 21.3976 9.766 19.6996 9.778C18.2826 9.778 17.1336 8.81 17.1336 7.615V7.567C17.1336 8.788 15.9846 9.778 14.5676 9.778C13.1486 9.778 11.9996 8.788 11.9996 7.567C11.9996 8.788 10.8506 9.778 9.43359 9.778C8.01659 9.778 6.86759 8.788 6.86759 7.567V7.615C6.86659 8.81 5.71759 9.778 4.30059 9.778Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H21",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84995 15.963V14.368C9.84995 13.004 8.05895 12.501 7.34795 13.664L5.50195 16.685",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStoreLogo);
export default __webpack_public_path__ + "static/media/changeStoreLogo.5a373449ed301482f01b6f69e5855037.svg";
export { ForwardRef as ReactComponent };